import { render, staticRenderFns } from "./dietGuidlineFood.vue?vue&type=template&id=f60fba6e&scoped=true&"
import script from "./dietGuidlineFood.vue?vue&type=script&lang=js&"
export * from "./dietGuidlineFood.vue?vue&type=script&lang=js&"
import style0 from "./dietGuidlineFood.vue?vue&type=style&index=0&id=f60fba6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60fba6e",
  null
  
)

component.options.__file = "dietGuidlineFood.vue"
export default component.exports